// extracted by mini-css-extract-plugin
export default {"row":"InvoiceInfo_row__rOKMu"};